// src/pages/Admin/DossierInscription/components/DossierDrawer.jsx

import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";

const TRANSITION_MS = 260;

export default function DossierDrawer({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  width = "max-w-5xl",
}) {
  const [mounted, setMounted] = useState(isOpen);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setMounted(true);
      requestAnimationFrame(() => setShown(true));
      return;
    }

    setShown(false);

    const timeout = setTimeout(() => setMounted(false), TRANSITION_MS);

    return () => clearTimeout(timeout);
  }, [isOpen]);

  if (!mounted) return null;

  return (
    <div className="fixed inset-0 z-[90]">
      <button
        type="button"
        className={`absolute inset-0 bg-slate-950/55 backdrop-blur-sm transition-opacity duration-300 ${
          shown ? "opacity-100" : "opacity-0"
        }`}
        onClick={onClose}
        aria-label="Fermer le panneau"
      />

      <aside
        className={`absolute right-0 top-0 h-full w-full ${width} transform overflow-hidden border-l border-slate-200 bg-white shadow-2xl transition-transform duration-300 dark:border-slate-800 dark:bg-slate-950 ${
          shown ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex h-full flex-col">
          <div className="border-b border-slate-200 bg-white px-4 py-4 dark:border-slate-800 dark:bg-slate-950 sm:px-6">
            <div className="flex items-start justify-between gap-4">
              <div className="min-w-0">
                <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
                  MonAppliClub
                </p>

                <h2 className="mt-1 text-xl font-bold text-slate-900 dark:text-white">
                  {title}
                </h2>

                {subtitle ? (
                  <p className="mt-1 text-sm leading-6 text-slate-600 dark:text-slate-300">
                    {subtitle}
                  </p>
                ) : null}
              </div>

              <button
                type="button"
                onClick={onClose}
                className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
                aria-label="Fermer"
              >
                <FaTimes />
              </button>
            </div>
          </div>

          <div className="min-h-0 flex-1 overflow-y-auto">{children}</div>
        </div>
      </aside>
    </div>
  );
}